require('./contactCenterLandingPage.scss');
// @vendors
const React = require('react');

class ContactCenterLandingPage extends React.Component {
    render() {
        return <div className="cc-usd-initial-screen__img"></div>
    }
}

module.exports.ContactCenterLandingPage = ContactCenterLandingPage;
